const hex = '[a-fA-F0-9]';

export const pattern = {
    /**
     * Name must begin with a letter. Must have 1+ letters total
     * May have any number of spaces or hyphens
     * Spaces and hyphens may not be adjacent
     * Spaces and hyphens must be adjacent to letters on both sides
     * (e.g. "this would-be a-valid name" but " this" and "this-" and "this -would not")
     */
    name: '^[a-zA-Z]+([ \\-]?[a-zA-Z])*$',
    /**
     * Match all phone number types. Explanation:
     *
     * `[\(\)\+\d-\.\s]{7,}`
     * The main expression requires seven or more of the preceding characters.
     *
     * `\+?`
     * The number may begin with a single optional `plus`.
     *
     * `(?![\s-\(\)\.\+]*$)`
     * Negative lookahead prevents the listed characters from comprising the
     * entire number. For example, "-------" should not be valid.
     */
    phone: '^(?![\\s\\-\\(\\)\\.\\+]*$)\\+?[\\(\\)\\+\\d\\-\\.\\s]{7,14}$',
    email: '[^\\s]+@[^\\s]+\\.{1}[^\\s]+',
    address: '.{5,}',
    /**
     * Match all unique identifier formats.
     * @example
     * ca761232ed4211cebacd00aa0057b223
     * CA761232-ED42-11CE-BACD-00AA0057B223
     * {CA761232-ED42-11CE-BACD-00AA0057B223}
     * (CA761232-ED42-11CE-BACD-00AA0057B223)
     */

    uuid: `^[\\{\\(]?${hex}{8}\\-?${hex}{4}\\-?${hex}{4}\\-?${hex}{4}\\-?${hex}{12}[\\}\\)]?$`,

    /**
     * Capture text within a Python byte literal which has the format `b'somebytes'`.
     */
    pythonBytes: /^b'(.+?)(\\n)?'$/,
    decimal: '^\\d*\\.?\\d*$',
};
